<zef-form
  [state]="state"
  (submit)="submit.emit(state)">

  <zui-user-data-fields
    [keyControlState]="state?.controls.key"
    [contentControlState]="state?.controls.content">
  </zui-user-data-fields>

  <!--
    Sensitive toggle - currently the secret/custom distinction is driven by which
    section's "Add" button opened this dialog (passed via dialog meta), so the toggle
    is redundant. Kept commented in case we want in-form selection again.
    NOTE: keep `sensitive` in the form value + the ZefFormsModule/MatSlideToggleModule
    imports while this is commented, so re-enabling is just uncommenting this block.
  -->
  <!-- <zef-form-field appearance="slide-toggle">
    <mat-slide-toggle [ngrxFormControlState]="state?.controls.sensitive">
      Sensitive (store as a secret variable - value stays hidden and is edited individually)
    </mat-slide-toggle>
  </zef-form-field> -->

  <ng-content></ng-content>

</zef-form>
